import React from 'react';
import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import "../assets/css/mystyle.css";
import axios from "axios";
import { CONFIG } from "../config/data";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const columns = [

 /*  { header: 'Drug ID(5 Chars)', key: 'drug_id' }, */
    { header: 'Drug Name', key: 'drug_name' },
    { header: 'Item Name', key: 'generic_name' },
    { header: 'Active Incredients', key: 'active_ingredients' },
    { header: 'Unit of Measure', key: 'unit_of_measure' }, 
    { header: 'Manufacturer', key: 'manufacturer' },  
    { header: 'Hsn code', key: 'hsn_code' },  
    { header: 'Igst', key: 'igst' },
    { header: 'Sgst', key: 'sgst' }, 
    { header: 'Cgst', key: 'cgst' }, 
    { header: 'Storage_bin', key: 'storage_bin' },
    { header: 'storage condition', key: 'storage_condition' }, 
    { header: 'Rx category', key: 'rx_category' }, 
    { header: 'Category', key: 'category' }, 
   
];

const workSheetName = 'Worksheet-1';
const workBookName = 'ItemTemplate';
const myInputId = 'myInput';
const workbook = new Excel.Workbook();
export default function App(props) {

   const saveExcel = async () => {
    try {
     
      const myInput = document.getElementById(myInputId);
      const fileName =  workBookName;
     
    
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
    //  console.log(typeof(data));
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 10;
        column.alignment = { horizontal: 'center' };
      });

      // loop through data and add each one to worksheet
   /*    data.forEach((singleData) => {
        worksheet.addRow(singleData);
      }); */

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, (row) => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach((singleCell) => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;

          // apply border
          worksheet.getCell(cellAddress).border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      });
    
      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();
     
      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
      toast.success("Item List Template has been generated successfully. ",{
        className:"toast-success"
      });
    } catch (error) {
      console.error('<<<ERRROR>>>', error);
      console.error('Something Went Wrong', error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };

  return (
    <>
      <style>
        {`
          table, th, td {
            border: 1px solid black;
            border-collapse: collapse;
            textAlign: center;
          }
           th, td { 
             padding: 4px;
           }
        `}
      </style>
      <div>
    
      
     
        <div>
          <button className="signupbtnclr abtn btdpml btn-margin" onClick={saveExcel}>Template</button>
        </div>

       

    
      </div>
    </>
  );
}
